import { Container as MuiContainer, ContainerProps as MuiContainerProps, styled } from "@mui/material";
const AppContainer = styled(MuiContainer)<MuiContainerProps>(({ theme }) => ({
    marginLeft: theme.custom.margin.left.appContainer,
    width: theme.custom.width.appContainer,
    height: "100%",
    maxWidth: "unset !important",
    display: "block",
    // display: "flex",
    // flexGrow: 1,
    // justifyContent: "space-between",
}));

export default AppContainer;
